import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Footer from "../../components/common/Footer";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";
import ContactHero from "./ContactHero";
import ContactFormSection from "./ContactFormSection";
import MapSection from "./MapSection";

const ContactUs = () => {


  return (
    <>
      <Helmet>
        <title>Contact Us | Utpann Production</title>
        <meta
          name="description"
          content="Contact Utpann Production for bio-fertilizer solutions."
        />
      </Helmet>

      <main>
        <ContactHero />

        <MapSection />
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ContactUs;
